import { useEffect } from "react";
import { prewarmAgentSession } from "@/lib/agent-prewarm";

function isInputBarField(target: EventTarget | null): boolean {
  return (
    target instanceof HTMLElement &&
    target.closest('[data-testid="input-bar-field"]') !== null
  );
}

export function useInputPrewarmIntent(): void {
  useEffect(() => {
    const onFocus = (event: FocusEvent) => {
      if (isInputBarField(event.target)) {
        prewarmAgentSession("input_focus");
      }
    };
    const onPointerDown = (event: PointerEvent) => {
      if (isInputBarField(event.target)) {
        prewarmAgentSession("input_click");
      }
    };
    document.addEventListener("focusin", onFocus, true);
    document.addEventListener("pointerdown", onPointerDown, true);
    return () => {
      document.removeEventListener("focusin", onFocus, true);
      document.removeEventListener("pointerdown", onPointerDown, true);
    };
  }, []);
}
